import { Callout } from "@octopusdeploy/design-system-components";
import * as React from "react";
import { TentacleDownloadButton } from "~/areas/infrastructure/components/TentacleDownloadButton/TentacleDownloadButton";
import ExternalLink from "~/components/Navigation/ExternalLink";
import { Note, UnstructuredFormSection } from "~/components/form";
import { TentacleCalloutHeading } from "./TentacleCalloutHeading";
export const WindowsListeningTentacleCallout: React.SFC<{
    thumbprint: React.ReactNode;
}> = ({ thumbprint }) => (<UnstructuredFormSection stretchContent={true}>
        <Callout type={"information"} title={"Installation Instructions"}>
            <TentacleCalloutHeading />
            <div>
                <p>
                    During setup, configure the Tentacle in <strong>listening</strong> mode, and ensure the Tentacle is configured to trust an Octopus Server with the thumbprint.
                </p>
                <Note>
                    Learn more about <ExternalLink href="ListeningTentacle">configuring Listening Tentacles</ExternalLink>.
                </Note>
                <TentacleDownloadButton />
                {thumbprint}
            </div>
        </Callout>
    </UnstructuredFormSection>);
WindowsListeningTentacleCallout.displayName = "WindowsListeningTentacleCallout"
export default WindowsListeningTentacleCallout;
